/**
 * Created by: cparaschiv
 * Date: 12.09.2013, 14:33
 */

(function(){
    'use strict';

    var helper = {};

    $.extend(helper, {

        containsSelectedItem: function(path, observable){
            if (observable)
                return path.indexOf(TS.Constants.selectedItemObs) > -1;
            else
                return path.indexOf(TS.Constants.selectedItem) > -1;
        },

        getRootPropertyName: function(path){
            var parts = (path || '').split('.');

            return parts[0];
        },

        getLeafPropertyName: function(path){
            var parts = (path || '').split('.');

            if (parts.length > 0)
                return parts[parts.length-1];

            return '';
        },

        getSelectedItemParent: function(path){
            var parts = (path || '').split('.'),
                parentPath,
                idx;

            parts = path.split('.');
            idx = parts.indexOf(TS.Constants.selectedItemObs);

            if (idx > 0) {
                parentPath = parts.slice(0, idx);
                return parentPath.join('.');
            }

            return '';
        },

        getSelectedItemPropPath: function(path){
            var parentPath;

            parentPath = helper.getSelectedItemParent(path);
            if (parentPath) {
                return parentPath + '.' + TS.Constants.selectedItem;
            }

            return '';
        },

        /*
         * Converts a knockout binding to an object
         * Example: 'value: Document.DummyTask.TaskName, enable: Document.HasDummyTask'
         *  Result: {
         *      value: 'Document.DummyTask.TaskName',
         *      enable: 'Document.HasDummyTask'
         *  }
         *
         *  @private
        */
        parseKoBinding: function(input){
            var ret = {},
                parts;

            if (typeof  input !== 'string')
                return ret;

            parts = input.split(',');
            $.each(parts, function(idx, part){
                var p = part.split(':'),
                    name, value;

                if (p.length == 2){
                    ret[p[0].trim()] = p[1].trim();
                }
            });

            return ret;
        },

        /**
         * Given a DOM element, tries to find the associated tsJqxGrid widget instance
         * and return its datasource (BindingListProperty)
         *
         * @private
         */
        getBindingList: function(element){
            var div, data,
                grid, blp;

            div = $(element).find('[data-role=tskendogrid]');
            if (div.length > 0) {
                blp = div.getKendoTsKendoGrid()._bindingListProperty;
                return blp;
            }

            div = $(element).find('div[role="grid"]').first();
            if (!div)
                return null;

            data = div.data && div.data('tsJqxGrid');
            if (data){
                grid = data.instance;
                blp = grid.dataSource;
                return blp;
            }

            return null;
        }
    });

    TS.BindingHelper = helper;

})();



